export function pruneCsv(value?: string): string {
    if (typeof value === 'number') return isNaN(value) ? '' : value;

    if (typeof value === 'string') {
        return value ? value.replace(/"/g, '""').trim() : '';
    }

    return value || '';
}
